/**
 * Resolves category thumbs from the shared Cloudinary CDN folder used by
 * Citizen and Mitra.
 */

export const CATEGORY_THUMB_CLOUDINARY_BASE =
  'https://res.cloudinary.com/dml5dugde/image/upload/f_auto,q_auto:best,c_fill,g_auto,w_512,h_512/v1/locsy/category-thumbnails/v1/sub';

const THUMB_ALIASES = {
  kirana_general_stores: 'kirana',
  provision_stores: 'provision',
  fancy_shops: 'fancy',
  stationery_office_supplies: 'stationery',
  book_stores_depots: 'books',
  gift_shops_toy_shops: 'gifts',
  cosmetic_shops: 'cosmetics',
  baby_care_shops: 'baby_care',
  hardware_shops: 'hardware',
  furniture_shops: 'furniture',
  cookers_pressure_cookers: 'cookers',
  gas_stoves_gas_cuts: 'gas_stoves',
  gas_cuts: 'gas_stoves',
  mixies_grinders: 'mixies',
  fans_ceiling_table_exhaust: 'fans',
  iron_boxes: 'irons',
  water_heaters_geysers: 'water_heaters',
};

const slug = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[/&,]+/g, ' ')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_');

const candidateKeys = ({
  categoryKey,
  value,
  subCategoryId,
  mainCategoryId,
  label,
} = {}) => {
  const out = [];
  const push = (v) => {
    const s = String(v || '').trim().toLowerCase();
    if (s && !out.includes(s)) out.push(s);
  };
  push(subCategoryId);
  push(mainCategoryId);
  const key = String(categoryKey || value || '').trim();
  if (key.includes('__')) {
    const parts = key.split('__');
    push(parts[parts.length - 1]);
    push(parts[0]);
  }
  push(key);
  push(slug(label));
  return out;
};

/** Pick thumb filename id (without .png) for a category row / register option. */
export function resolveCitizenThumbKey(input = {}) {
  const candidates = candidateKeys(input);
  for (const id of candidates) {
    if (THUMB_ALIASES[id]) return THUMB_ALIASES[id];
  }
  return candidates[0] || '';
}

/**
 * Prefer admin-uploaded thumbnail_url when present; else citizen asset path.
 */
export function resolveCategoryThumbSrc(input = {}) {
  const uploaded = String(input.thumbnailUrl || input.thumbnail_url || '').trim();
  if (uploaded) {
    if (/^https?:\/\//i.test(uploaded)) {
      if (
        uploaded.includes('res.cloudinary.com/') &&
        uploaded.includes('/image/upload/') &&
        !uploaded.includes('/f_auto,q_auto:best,')
      ) {
        return uploaded.replace(
          '/image/upload/',
          '/image/upload/f_auto,q_auto:best,c_fill,g_auto,w_512,h_512/'
        );
      }
      return uploaded;
    }
    if (uploaded.startsWith('/')) {
      const origin =
        typeof window !== 'undefined' ? window.location.origin : '';
      return `${origin}${uploaded}`;
    }
    return uploaded;
  }

  const key = resolveCitizenThumbKey(input);
  if (!key) return '';
  return `${CATEGORY_THUMB_CLOUDINARY_BASE}/${encodeURIComponent(key)}.png`;
}
